//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: ${({ width = "265px" }) => width};
    gap: 10px;
    & label {
        color: var(--dark-4);
        font-weight: 600;
        font-size: 14px;
        transition: 0.35s;
    }
    &.disabled label {
        color: var(--purple-4);
    }
`;
export const Content = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
    &:not(.disabled):focus > div:first-child {
        color: var(--purple-2);
        border-color: var(--purple-2);
        & svg {
            fill: var(--purple-2);
        }
    }
`;